import '../styles/pages/Aboutus.scss';
import banner from '../assets/aboutus-banner.svg'
import mobileBanner from '../assets/phone/aboutus.svg';
import antivirusIcon from '../assets/icons/aboutus/antivirus.svg';
import chatIcon from '../assets/icons/aboutus/chat.svg';
import keysIcon from '../assets/icons/aboutus/cles.svg';
import compatibilitIcon from '../assets/icons/aboutus/comptabilite.svg';
import fuseeIcon from '../assets/icons/aboutus/fusee.svg';
import globeIcon from '../assets/icons/aboutus/globe.svg';
import handshakeIcon from '../assets/icons/aboutus/handshake.svg';
import speedIcon from '../assets/icons/aboutus/speed.svg';
import timeIcon from '../assets/icons/aboutus/time.svg';
import validationIcon from '../assets/icons/aboutus/validation.svg';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
    const { t } = useTranslation();
    return(
        <div className="main-container">
            <div className="aboutus-banner">
                <img src={window.innerWidth > 768 ? banner : mobileBanner} alt="About Us Banner" />
                <h1>{t('about.banner.title')}</h1>
            </div>
            <div className='aboutus-content'>
                <div className='aboutus-title'>
                    <h3> {t('about.content.subtitle')} </h3>
                    <h2> {t('about.content.title')} <span className='colored'>{t('about.content.colored')}</span>. </h2>
                </div>
                <ul className='aboutus-content'>
                    <li>{t('about.content.p1')} </li>
                    <li>{t('about.content.p2')} </li>
                    <li>{t('about.content.p3')}</li>
                </ul>
            </div>
            <div className='aboutus-services-container'>
                <h2> {t('about.services.title')} <span className='colored'>{t('about.services.colored')}</span> </h2>
                <div className='aboutus-services'>
                    <div className='aboutus-service'>
                        <img src={handshakeIcon} alt="handshake" />
                        <h3>{t('about.services.s1.title')}</h3>
                        <span> {t('about.services.s1.description')}</span>
                    </div>
                    <div className='aboutus-service'>
                        <img src={validationIcon} alt="validation" />
                        <h3>{t('about.services.s2.title')}</h3>
                        <span> {t('about.services.s2.description')} </span>
                    </div>
                    <div className='aboutus-service'>
                        <img src={speedIcon} alt="speed" />
                        <h3>{t('about.services.s3.title')}</h3>
                        <span> {t('about.services.s3.description')} </span>
                    </div>
                </div>
            </div>
            <div className="aboutus-expertise">
                <h2> {t('about.expertise.title')} <br/><span className='colored'>{t('about.expertise.colored')}</span> </h2>
                <div className='aboutus-expertise-container'>
                    <div className="expertise">
                        <div className='expertise-title'>
                            <img src={timeIcon} alt="time icon" />
                            <span>{t('about.expertise.e1.title')} </span>
                        </div>
                        <span>{t('about.expertise.e1.description')}</span>
                    </div>
                    <div className="expertise">
                        <div className='expertise-title'>
                            <img src={antivirusIcon} alt="security icon" />
                            <span>{t('about.expertise.e2.title')}</span>
                        </div>
                        <span>{t('about.expertise.e2.description')}</span>
                    </div>
                    <div className="expertise">
                        <div className='expertise-title'>
                            <img src={compatibilitIcon} alt="Comptabilité icon" />
                            <span>{t('about.expertise.e3.title')}</span>
                        </div>
                        <span>{t('about.expertise.e3.description')}</span>
                    </div>
                </div>
            </div>
            <div className="aboutus-why-us">
                <h2> {t('about.whyUs.title')} <br/><span className='colored'>{t('about.whyUs.colored')}</span> ? </h2>
                <div className='aboutus-reasons-container'>
                    <div className="reason">
                        <img src={fuseeIcon} alt="accompagnement personnalisé icon" />
                        <span>{t('about.whyUs.r1')}</span>
                    </div>
                    <div className="reason">
                        <img src={chatIcon} alt="Tarifs transparents icon" />
                        <span>{t('about.whyUs.r2')}</span>
                    </div>
                    <div className="reason">
                        <img src={globeIcon} alt="expertise icon" />
                        <span>{t('about.whyUs.r3')}</span>
                    </div>
                    <div className="reason">
                        <img src={keysIcon} alt="solution icon" />
                        <span>{t('about.whyUs.r4')}</span>
                    </div>
                </div>
            </div>
            <div className="aboutus-footer">
                <h2> {t('about.footer.title')} <span className='colored'>{t('about.footer.colored')}</span> {t('about.footer.end')} </h2>
                <a href='/contact'><button> {t('about.footer.button')} </button></a>
            </div>
        </div>
    )
}

export default AboutUs;
